const initialState = {
};

export const previewImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOAD_PREVIEW_IMPORT":
      return {
        ...state,
        [action.payload.fileName]: action.payload.data,
      };
    default:
      return state;
  }
};